import React from "react";
import { useQuery } from "react-query";
import ConcurrentSessionService from "../../Services/ConcurrentSession";
import SingleSession from "./SingleSession";
import { useNavigate } from "react-router-dom";
import "./ConcurrentTable.scss";
import { isArray } from "lodash";
import { OverlayLoader } from "../Loader/Loader";
/**
 * Component displaying a table of concurrent sessions.
 * @returns JSX.Element
 */
const ConcurrentTable = () => {
  // Define a query key for React Query to identify this data fetching operation
  const queryKey = ["sessions"];
  const navigate = useNavigate();
  // Define the function to fetch the sessions data
  const fetchSessions = async () => {
    const res = await ConcurrentSessionService.getSessions();
    return res.data.sessions;
  };

  // Fetch sessions data using React Query hook
  const {
    data: sessions = [],
    isLoading,
    isFetching,
    refetch,
  } = useQuery(queryKey, fetchSessions, {
    refetchOnWindowFocus: false,
  });

  // Redirect to dashboard if there are no sessions and loading is complete
  if (sessions.length === 0 && !isLoading) navigate("/sales");

  if (isFetching) return <OverlayLoader />;
  if (!isArray(sessions)) return null;
  return (
    <div i2c-container="container xl">
      <div className="table_overflow">
        <table className={"table_default"}>
          <thead>
            <tr>
              <th>Session</th>
              <th>IP Address</th>
              <th>Browser</th>
              <th>Device Type</th>
              <th>Login Date</th>
              <th>Login Time</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {/* Map through sessions and render SingleSession component for each */}
            {sessions?.map((session, index) => (
              <SingleSession
                key={session.id ?? index}
                session={session}
                sessionNumber={index + 1}
                onSessionDelete={refetch}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ConcurrentTable;
